import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
    PageHeader,
    Select,
    Card,
    Row,
    Col,
    Divider,
    Spin,
    Button,
    notification,
    Popconfirm
} from "antd"
import Individual from "./Individual"
import Enterprise from "./Enterprise"
import { apiClient, apiSender } from "../../../api.js"
import {
    getAccId,
    getUsername,
    CheckTokenExp,
    getEmail,
    getMobile,
    getPackage,
    getCompany,
    token
} from "../../../config"

const { Option } = Select

export default function RequestSender(props) {
    const { isRequestSender, isEcomLimit } = props
    let history = useHistory()
    const [countSender, setCountSender] = useState(0)
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState(1) //1=individual, 2=enterprise
    // const typeObj = { Individual: 1, Enterprise: 2 }

    const [data, setData] = useState({
        RSD_FIRST_NAME: "",
        RSD_LAST_NAME: "",
        RSD_EMAIL: getEmail() || "",
        RSD_CONTACT_NAME: "",
        RSD_CONTACT_NUMBER: getMobile() || "",
        RSD_POSITION: "",
        RSD_WEBSITE: "",
        RSD_IDEN_DOC: [],
        RSD_WHITELIST_DOC: {},
        senderNamelength: 0,
        senderNameCount: 11,
        RSD_LIST_SENDER_NAME: "",
        RSD_LIST_REASON_USE: [],
        RSD_LIST_REASON_USE_COMMENT: "",
        messageLength: 0,
        messageCount: 100,
        RSD_LIST_EX_TEXT: "",
        RSD_LIST_IS_WHITELIST: false,
        error_reasonUseComment: false,
        sig_img_indi: [],
        sig_img_enterP: [],
        RSD_CO_SEAL: [],
        RSD_LIST_USER_FLOW: null,
        senderlist: null,
        RSD_LIST_REQUEST: 1,
        sig_type: "1", //signature type upload
        sender_id: "",
        RSD_TYPE: 0
    })

    const [openPop, setOpenPop] = useState(false)
    const [errorText, setErrorText] = useState(false)

    const routes = [
        {
            path: "RequestSender",
            breadcrumbName: "Sender Name Registration",
        },
    ]

    const handleChangeType = (value) => {
        data.RSD_TYPE = value
        setType(value)
    }

    const changeFile = (file, name) => {
        setData({
            ...data,
            [name]: file,
        })
    }

    const handleChangeInput = (e, name) => {
        if (name === "RSD_LIST_SENDER_NAME") {
            CountMessageNew(
                e.target.value,
                name,
                "senderNamelength",
                "senderNameCount"
            )
        } else if (name === "RSD_LIST_EX_TEXT") {
            CountMessageNew(e.target.value, name, "messageLength", "messageCount")
        } else if (name === "RSD_LIST_REASON_USE_COMMENT") {
            setData({
                ...data,
                [name]: e.target.value,
            })
            if (/[^a-zA-Z\s]/.test(e.target.value)) {
                //thai
                setErrorText(true)
            } else {
                //eng
                setErrorText(false)
            }
        } else {
            if (name === "RSD_CONTACT_NUMBER") {

                const regex = new RegExp("^[0][0-9]*$")
                if (!regex.test(e.target.value)) {
                    openNotification(
                        "warning",
                        "Please enter phone number only ex. 0XXXXXXXXX"
                    )
                    return e.target.value = ""
                }
            }
            setData({
                ...data,
                [name]: e.target.value,
            })
        }
    }

    const CountMessageNew = (message, name, textLength, textCount) => {
        let len = message.length
        if (len <= data[textCount]) {
            setData({
                ...data,
                [name]: message,
                [textLength]: len,
            })
        }
    }

    const onChangeCheckBox = (e, name) => {
        if (name === "RSD_LIST_IS_WHITELIST") {
            let rsdListReq = 1
            if (e.target.checked) rsdListReq = 2
            setData({
                ...data,
                [name]: e.target.checked,
                RSD_LIST_REQUEST: rsdListReq,
            })
        } else {
            setData({
                ...data,
                [name]: e.target.checked,
            })
        }
    }

    const handelChangeCheckboxGroup = (value, name) => {
        setData({ ...data, [name]: value })
    }

    const ClearData = () => {
        setData({
            ...data,
            senderNamelength: 0,
            senderNameCount: 11,
            messageLength: 0,
            messageCount: 100,
            RSD_LIST_REQUEST: 1
        })
    }

    const handleClickNext = () => {
        try {
            let _countSender = 1
            if (type === 1) {
                const regex = new RegExp("^[0][0-9]{9}$")
                if (!regex.test(data.RSD_CONTACT_NUMBER)) {
                    openNotification(
                        "warning",
                        "Contact no invalid"
                    )
                }
            }

            if (_countSender > 2) {
                openNotification(
                    "warning",
                    "You already reach to maximum allowed to a Demo version. Please purchase package use this function"
                )
            } else {

                var errormsg = [], haveError = false
                if (data.RSD_FIRST_NAME === "") errormsg.push("First Name")
                if (data.RSD_LAST_NAME === "") errormsg.push("Last Name")
                if (data.RSD_LIST_SENDER_NAME === "") errormsg.push("Sender Name")
                if (!data.RSD_IDEN_DOC || data.RSD_IDEN_DOC.length <= 0) errormsg.push("Identification Documents")
                if (data.RSD_LIST_IS_WHITELIST && (!data.RSD_WHITELIST_DOC || Object.keys(data.RSD_WHITELIST_DOC).length === 0)) errormsg.push("Request Whitelist Documents")

                switch (type) {
                    case 1:
                        if (data.RSD_EMAIL === "") errormsg.push("EMAIL")
                        if (data.RSD_CONTACT_NUMBER === "") {
                            errormsg.push("Contact Number")
                        } else {
                            const regex = new RegExp("^[0][0-9]{9}$")
                            if (!regex.test(data.RSD_CONTACT_NUMBER)) {
                                errormsg.push("Contact no invalid")
                            }
                        }
                        break
                    case 2:
                        if (data.RSD_POSITION === "") errormsg.push("Position")
                        break
                    default:
                        break
                }
                haveError = (errormsg.length > 0)
                if (haveError) {
                    let msg_error = ""
                    errormsg.forEach((msg) => {
                        msg_error += msg + "\n"
                    })
                    msg_error.substr(msg_error.lastIndexOf("\n"))
                    openNotification(
                        "warning",
                        "Plase fill the information in require box\n" + msg_error
                    )
                }
                else {
                    onSaveData()
                }
            }
        } catch (error) {
            setCountSender(2)
            console.log("error: ", error)
        }
    }

    const openNotification = (type, message) => {
        notification[type]({
            className: `reqSenderNoti ${type}`,
            message: message ? message : "Required field",
            description: message,
            // duration: 0,
        })
    }

    const onSaveData = () => {
        if (!CheckTokenExp()) {
            setLoading(true)
            const formData = new FormData()

            let datasender = JSON.stringify({
                id: data.sender_id,
                name: data.RSD_LIST_SENDER_NAME,
                request_whitelist: data.RSD_LIST_IS_WHITELIST || false,
                request_sender: data.RSD_LIST_IS_WHITELIST ? 2 : 1,
            })

            formData.append("account", getAccId())
            formData.append("username", getUsername())
            formData.append("list_request", data.RSD_LIST_REQUEST)
            formData.append("request_type", type)
            formData.append("firstName", data.RSD_FIRST_NAME)
            formData.append("lastName", data.RSD_LAST_NAME)
            formData.append("email", data.RSD_EMAIL)
            formData.append("contact_number", data.RSD_CONTACT_NUMBER)
            formData.append("position", data.RSD_POSITION)
            formData.append("datasender_list", datasender)
            formData.append("iden_doc", data.RSD_IDEN_DOC[0])
            formData.append("whitelist_doc", data.RSD_WHITELIST_DOC)

            apiClient
                .post("api/sender/save", formData, {
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'Authorization': `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    if (response.data.statusCode === "200") {
                        openNotification("success", response.data.statusDesciption)
                        history.push("/communication/sender/list")
                    } else if (response.data.statusCode === "901") {
                        openNotification("warning", response.data.statusDesciption)
                    } else {
                        openNotification("error", response.data.statusDesciption)
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    openNotification("error", error)
                    setLoading(false)
                })
        } else {
            window.location.href = "logout"
        }
    }

    const showPopconfirm = () => {
        setOpenPop(true)
    }

    const handleCancel = () => {
        setOpenPop(false)
    }

    const limitSender = () => {
        if (!CheckTokenExp()) {

            let req = JSON.stringify({
                "accLogin": parseInt(getAccId()),
            });

            apiClient.post('api/sender/limitSender', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    var json = data.data;
                    if (json.statusCode !== "200") {
                        window.location.href = "communication/sender/list/";
                    }
                })
                .catch(error => {
                });
        } else {
            window.location.href = "logout";
        }
    }

    const checkIsRequestSender = () => {
        if (!isRequestSender) {
            history.push("/communication/sender/list")
        }
    }

    useEffect(() => {
        const reqSenderList = JSON.parse(sessionStorage.getItem("requestSenderList"))
        let senderId = ""
        for (let obj in reqSenderList) {
            if (obj === "sender_id") {
                senderId = reqSenderList[obj]
            }
            if (obj === "request-whiteList" && Number(reqSenderList[obj]) === 3) {
                setData({
                    ...data,
                    RSD_LIST_REQUEST: Number(reqSenderList[obj]),
                    RSD_LIST_IS_WHITELIST: true,
                    sender_id: senderId,
                })
            }
        }
    }, [])

    useEffect(() => {
        var _getCompany = getCompany().trim().split(" ")
        if (_getCompany.length > 0) {
            setData({
                ...data,
                RSD_FIRST_NAME: _getCompany[0],
                RSD_LAST_NAME: _getCompany.length >= 2 ? _getCompany[1] : "",
            })
        }
    }, [])

    useEffect(() => {
        limitSender()
        checkIsRequestSender()
    }, [])

    return (
        <div className="animated fadeIn">
            <PageHeader breadcrumb={{ routes }}>
                <Row gutter={8} type="flex" justify="end">
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div style={{ textAlign: "right" }}>
                            <Select
                                defaultValue={type}
                                style={{ width: 150 }}
                                suffixIcon={<span className="fa fa-angle-down" />}
                                onChange={handleChangeType}
                            >
                                <Option value={1}>Individual Form</Option>
                                <Option value={2}>Enterprise Form</Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
            </PageHeader>
            <div className="content" style={{ minHeight: 200 }}>
                <Spin spinning={loading}>
                    <Row style={{ display: "flex", justifyContent: "center" }}>
                        <Col span={20}>
                            <Card
                                className="card-content"
                                style={{
                                    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.16)",
                                    borderRadius: "8px",
                                }}
                            >
                                {type === 1 ? (
                                    <Individual
                                        data={data}
                                        handleChangeInput={handleChangeInput}
                                        handelChangeCheckboxGroup={handelChangeCheckboxGroup}
                                        onChangeCheckBox={onChangeCheckBox}
                                        errorText={errorText}
                                        changeFile={changeFile}
                                    />
                                ) : (
                                    <Enterprise
                                        data={data}
                                        handleChangeInput={handleChangeInput}
                                        handelChangeCheckboxGroup={handelChangeCheckboxGroup}
                                        onChangeCheckBox={onChangeCheckBox}
                                        errorText={errorText}
                                        changeFile={changeFile}
                                    />
                                )}

                                <Divider />

                                <div style={{ float: "right" }}>
                                    {/* <Button style={{ marginRight: "8px" }} onClick={ClearData}>
                                        Clear Data
                                    </Button> */}

                                    <Popconfirm
                                        title="The sender request process typically takes 5–7 business days to complete."
                                        open={openPop}
                                        onConfirm={handleClickNext}
                                        onCancel={handleCancel}
                                        overlayClassName="ants-popconfirm-custom"
                                        placement="topRight"
                                    >
                                        <Button onClick={showPopconfirm}>Next</Button>
                                    </Popconfirm>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Spin>
            </div>
        </div>
    )
}
